import { useRoute } from "@bcm-dev/bcms-vite";
import { Autopay, Biller } from "model";
import React from "react";

import ButtonContainer from "compid/shared/containers/ButtonContainer";
import { ActiveBadge, PromoInfoView } from "compid/shared/views/PromoView/components/views/PromoInfoView";
import WidgetView, { WidgetMainContentView } from "compid/shared/views/WidgetView";
import UIButton from "compid/ui/UIButton";
import AddedAutopayDescription from "./components/AddedAutopayDescription";

import { SVGAsset } from "res";
import "./styles.css";

/**
 * @function BillerDetailsAutopayUpsell
 * @param {Biller} biller - The biller currently shown in the details page
 * @return {React.Component}
 * @description The autopay component for the biller details page
 * @example
 * <BillerDetailsAutopayUpsell biller={ biller } />
 */
export default function BillerDetailsAutopayUpsell(props) {
    const navigate = useRoute();
    // If no biller has been passed, then get the first biller in the global state
    const biller = props.biller instanceof Biller ? props.biller : Biller.firstInstanceOf();
    // addAutopay :: navigate to the add autopay workflow
    const addAutopay = evt => navigate(`/addAutopayWorkflow/${ biller.id }`, { "state" : { "goBack" : true } });
    const autopays = Autopay.getByBillerID(biller.id);

    const hasAutopays = autopays.length > 0;

    const autopayClassName = hasAutopays && "active-autopay";

    const activeAutopays = autopays.map(autopay => {
        return (
            <div className="flex-container flex-horizontal" key={ `Autopay_${ autopay.id }` }>
                <AddedAutopayDescription autopay={ autopay } />
            </div>
        );
    }, []);

    return (
        <div className={`${ autopayClassName } biller-details-upsell-view biller-details-autopay-upsell`}>
            <WidgetView>
                <div className="flex-container flex-vertical flex-width">
                    <WidgetMainContentView>
                        <PromoInfoView 
                            icon={ <SVGAsset id="TwoArrowsIcon" className="upsell-icon" /> } 
                            title="Autopay" 
                            description={ !hasAutopays && "Add automatic payments so your bill is always paid on time" }
                            activeBadge={ hasAutopays && <ActiveBadge /> }
                            dataPoint="Biller_Details_Add_Autopay" 
                            >

                            { activeAutopays }
                        </PromoInfoView>

                        { !hasAutopays && 
                            <ButtonContainer>
                                <UIButton className="secondary-button" onClick={ addAutopay } dataPoint="Biller_Details_Add_Autopay">
                                    <span>Add autopay</span>
                                </UIButton>
                            </ButtonContainer> }
                    </WidgetMainContentView>

                    { hasAutopays &&
                        <div className="flex-container align-center upsell-notice">
                            <SVGAsset id="LightBulbIcon" className="left-icon" />

                            <a>
                                <div onClick={ addAutopay }>
                                    <b data-point="Active_Autopay_Add_Another_Payment">Add another automatic payment</b>
                                    <SVGAsset id="RightChevronIcon" className="align-center more-chevron" />
                                </div>
                            </a>
                        </div> }
                </div>
            </WidgetView>
        </div>
    );
}